//* Style
import VTB_BranchTableSectionStyle from './style';

//* Components
import Container from 'components/common/Container';

const VTB_BranchTableSection = () => {
	return (
		<VTB_BranchTableSectionStyle>
			<Container
				section
				className={'table-wrapper'}>
				<table>
					<thead>
						<tr>
							<th>Название банка</th>
							<th>Адрес</th>
							<th>Регион</th>
							<th>Город</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Киевяна 19</td>
							<td>Арабкир</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Комитас 60/2</td>
							<td>Арабкир</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Баграмяна 56/73</td>
							<td>Арабкир</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Комитаса 41/74</td>
							<td>Арабкир</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Комитаса 26</td>
							<td>Арабкир</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, пр. Азатутяна 9, кв. 2</td>
							<td>Арабкир</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Баграмяна 3, 4/2</td>
							<td>Арабкир</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Азатутяна 20/37</td>
							<td>Арабкир</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Аароняна 2</td>
							<td>Арабкир</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Агароняна 12/5</td>
							<td>Арабкир</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г.Ереван, Верин Антараин 135, 40</td>
							<td>Арабкир</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Маштоца 10</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Ханджяна 19</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Г. Лусаворича 13а</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Абовян 13</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Абовян 36/2</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Корюна 6</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Т.Меца 10</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Аршакуняца 34</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Московяна 18/Баграмян 2/83</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, пр. Маштоца 5</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Абовяна 7</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Пушкина 3/1</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Хоренаци 33 ТЦ "Ташир"</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Т.Меца 16/Хоренаци 30/1</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г.Ереван,ул.Нар-Дос 75/70</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Саряна 22</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г.Ереван,ул.Баграмян 19</td>
							<td>Кентрон</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Т. Меца 48/41</td>
							<td>Эребуни</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул.Тигран Меца 50</td>
							<td>Эребуни</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул, Т. Меца 86</td>
							<td>Эребуни</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Эребуни 17/1</td>
							<td>Эребуни</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Эребуни 31-85</td>
							<td>Эребуни</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, пер. Аванесова 8/2</td>
							<td>Эребуни</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, пер. Арцаха 32</td>
							<td>Эребуни</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Г. Нжде 8 </td>
							<td>Шенгавит</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Багратуняц 13/113</td>
							<td>Шенгавит</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Багратуняца 5/3</td>
							<td>Шенгавит</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Г. Нжде 24/3</td>
							<td>Шенгавит</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Манандяна 33/3 //ГО</td>
							<td>Шенгавит</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Арташисяна 86/3</td>
							<td>Шенгавит</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Себастия 14/55</td>
							<td>Малатиа-Себастиа</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Кургиняна 7/55</td>
							<td>Малатиа-Себастиа</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Себастиа 141/5</td>
							<td>Малатиа-Себастиа</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Оганова 21</td>
							<td>Малатиа-Себастиа</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. З. Андраника 71/7</td>
							<td>Малатиа-Себастиа</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г.Ереван, ул.Раффи 55/1</td>
							<td>Малатиа-Себастиа</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Себастиа 32</td>
							<td>Малатиа-Себастиа</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Себастиа 141/5</td>
							<td>Малатиа-Себастиа</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Международный Аэропорт “Звартноц”</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Цицернакаберд 3</td>
							<td>Малатиа-Себастиа</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Башинджагяна 188/6</td>
							<td>Аджапняк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Шинарарнери 25/40</td>
							<td>Аджапняк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Маргаряна 8/1</td>
							<td>Аджапняк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Бабаджаняна 87/3</td>
							<td>Аджапняк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул.Шираза 20</td>
							<td>Аджапняк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Петросяна 19/2</td>
							<td>Давташен</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Т. Петросян 25/5</td>
							<td>Давташен</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Т. Петросян 37/7</td>
							<td>Давташен</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул.А.Микояна 109/8</td>
							<td>Давташен</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Саркавага 123 </td>
							<td>Канакер Зейтун</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Дро 15</td>
							<td>Канакер Зейтун</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Рубинянц 15/5</td>
							<td>Канакер Зейтун</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Исаакяна 3/1а</td>
							<td>Аван</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Ачаряна 30</td>
							<td>Аван</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, Аван, Оганнесяна 24/7</td>
							<td>Аван</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Ашхабада 2/9</td>
							<td>Аван</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Царав Ахбюр 55/17 48</td>
							<td>Аван</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Б. Мурадяна 1/92</td>
							<td>Нор Норк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Гаи 16</td>
							<td>Нор Норк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Вильнюса 3/84</td>
							<td>Нор Норк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Тотовенца 14/1</td>
							<td>Нор Норк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. А. Микояна 2/4</td>
							<td>Нор Норк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Тевосяна 52/2</td>
							<td>Нор Норк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Гаи 10/3</td>
							<td>Нор Норк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Молдовакана 27/1</td>
							<td>Нор Норк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ереван, ул. Багреванд 5</td>
							<td>Нор Норк</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г.Ереван, Арменакян 127</td>
							<td>Норк Мараш</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г.Ереван, ул. Нубарашен 9</td>
							<td>Нубарашен</td>
							<td>Ереван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Мусалер, ул. Франца Верфела 1</td>
							<td>Армавир</td>
							<td>Мусалер</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Мердзаван, Ереванян</td>
							<td>Армавир</td>
							<td>Мердзаван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Эчмиадзин, (ул. Маштоца)</td>
							<td>Армавир</td>
							<td>Эчмиадзин</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Эчмиадзин, ул. Маштоца 18/7а</td>
							<td>Армавир</td>
							<td>Эчмиадзин</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Эчмиадзин, ул. Арагаца Масива 4/56</td>
							<td>Армавир</td>
							<td>Эчмиадзин</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Эчмиадзин, ул. Баграмяна 2 </td>
							<td>Армавир</td>
							<td>Эчмиадзин</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>С. Джрарби</td>
							<td>Армавир</td>
							<td>Джрарби</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>с. Овташат, ул. Зинавана 5</td>
							<td>Армавир</td>
							<td>Овташат</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Мецамор, 1-ый кв., N3-4</td>
							<td>Армавир</td>
							<td>Мецамор</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Армавир, ул. Ереваняна 21/1</td>
							<td>Армавир</td>
							<td>Армавир</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Армавир, ул. Мясникяна 15а </td>
							<td>Армавир</td>
							<td>Армавир</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>с. Мясникян, трасса Армавир-Талин</td>
							<td>Армавир</td>
							<td>Мясникян</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>с. Аракс, ул. Григоряна 45</td>
							<td>Армавир</td>
							<td>Аракс</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Баграмян, ул. Араратяна 42 </td>
							<td>Армавир</td>
							<td>Баграмян</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Масис, Араратян 3</td>
							<td>Арарат</td>
							<td>Масис</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Масис, ул. Анрапетутяна 7/16</td>
							<td>Арарат</td>
							<td>Масис</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Арташат, ул. Огостоса 23 </td>
							<td>Арарат</td>
							<td>Арташат</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Арташат, ул. Огостоси 23/46</td>
							<td>Арарат</td>
							<td>Арташат</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Веди, ул. Араратян 49</td>
							<td>Арарат</td>
							<td>Веди</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Веди, ул. Гаи 11</td>
							<td>Арарат</td>
							<td>Веди</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Арарат, ул. Банаван 8/7-1</td>
							<td>Арарат</td>
							<td>Арарат</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Арарат, ул. Шаумян 24/1</td>
							<td>Арарат</td>
							<td>Арарат</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Аштарак, ул. В. Петросяна 18 </td>
							<td>Арагацотн</td>
							<td>Аштарак</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Аштарак, ул. Т.Меца 1 </td>
							<td>Арагацотн</td>
							<td>Аштарак</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>С. Арагацаван, ул. Грибоедова 9</td>
							<td>Арагацотн</td>
							<td>Арагацаван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Талин, ул. Шаумяна 1</td>
							<td>Арагацотн</td>
							<td>Талин</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Апаран, Баграмяна 14</td>
							<td>Арагацотн</td>
							<td>Апаран</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Цахкаовит, Бжшкян 9/4</td>
							<td>Арагацотн</td>
							<td>Цахкаовит</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Егвард, ул. Ереваняна 8</td>
							<td>Котайк</td>
							<td>Егвард</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Бюрегаван, Абовян 15</td>
							<td>Котайк</td>
							<td>Бюрегаван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Абовян, ул. Анрапетутяна 1/66</td>
							<td>Котайк</td>
							<td>Абовян</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Абовян, Атиси 1/81</td>
							<td>Котайк</td>
							<td>Абовян</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Абовян, ул. Красноармейцев 25</td>
							<td>Котайк</td>
							<td>Абовян</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Абовян, ул. Е. Петросяна 1/16</td>
							<td>Котайк</td>
							<td>Абовян</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Чаренцаван, 4-й квартал, д. 4 </td>
							<td>Котайк</td>
							<td>Чаренцаван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Чаренцаван, Туманяна 48</td>
							<td>Котайк</td>
							<td>Чаренцаван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Чаренцаван, Терян 1</td>
							<td>Котайк</td>
							<td>Чаренцаван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Раздан, (пл. Сагманадрутяна)</td>
							<td>Котайк</td>
							<td>Раздан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Раздан, ул. З. Андраника 131/2</td>
							<td>Котайк</td>
							<td>Раздан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Раздан, Спандаряна 13/1</td>
							<td>Котайк</td>
							<td>Раздан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Раздан, ул. Горцаранаина 1</td>
							<td>Котайк</td>
							<td>Раздан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>с. Меградзор, ул. 1-ая</td>
							<td>Котайк</td>
							<td>Меградзор</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г.Цахкадзор, ул.Г.Магистроса 13</td>
							<td>Котайк</td>
							<td>Цахкадзор</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Севан, Саргис Севанцу 9а </td>
							<td>Гегаркуник</td>
							<td>Севан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Севан, ул. Наиряна 155</td>
							<td>Гегаркуник</td>
							<td>Севан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>с. Цовагюх</td>
							<td>Гегаркуник</td>
							<td>Севан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Чамбарак, Г. Нжде 124</td>
							<td>Гегаркуник</td>
							<td>Чамбарак</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Камо, Центральная площадь 9/1</td>
							<td>Гегаркуник</td>
							<td>Камо</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Камо, ул. Бошнагяна 17 </td>
							<td>Гегаркуник</td>
							<td>Камо</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Мартуни, ул. Мясникяна 33</td>
							<td>Гегаркуник</td>
							<td>Мартуни</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Мартуни, ул. Ереваняна 37</td>
							<td>Гегаркуник</td>
							<td>Мартуни</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Варденис, ул. Азгалдяна 7</td>
							<td>Гегаркуник</td>
							<td>Варденис</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Варденис, ул. Романа 7</td>
							<td>Гегаркуник</td>
							<td>Варденис</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Дилиджан, ул. Мясникяна 53</td>
							<td>Тавуш</td>
							<td>Дилиджан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Дилиджан, М.Горки 19 </td>
							<td>Тавуш</td>
							<td>Дилиджан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Иджеван, ул. А. Меликбекяна 10</td>
							<td>Тавуш</td>
							<td>Иджеван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Иджеван, ул. Анкахутяна 11</td>
							<td>Тавуш</td>
							<td>Иджеван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Берд, Маштоца дом 26/6.</td>
							<td>Тавуш</td>
							<td>Берд</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>с. Арцваберд, 1 ул., дом 48</td>
							<td>Тавуш</td>
							<td>Берд</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ноемберян, Ереванян 5</td>
							<td>Тавуш</td>
							<td>Ноемберян</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>с. Баграташен ул. 19 11/2</td>
							<td>Тавуш</td>
							<td>Баграташен</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>с. Кохб 1</td>
							<td>Тавуш</td>
							<td>Кохб</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Спитак, ул. Ухих Камарашар 1</td>
							<td>Лори</td>
							<td>Спитак</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ванадзор, ул. Тиграна Меца 53 </td>
							<td>Лори</td>
							<td>Ванадзор</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ванадзор, ул. Гр. Лусаворича N38/1</td>
							<td>Лори</td>
							<td>Ванадзор</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ванадзор, М. Мкртчяна 8</td>
							<td>Лори</td>
							<td>Ванадзор</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ванадзор, ул. Агаяна 67/2-1</td>
							<td>Лори</td>
							<td>Ванадзор</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ванадзор, Баграмян 21/15</td>
							<td>Лори</td>
							<td>Ванадзор</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ванадзор, Туманяна 1/1-10</td>
							<td>Лори</td>
							<td>Ванадзор</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Степанаван, ул. Г. Нжде 9 </td>
							<td>Лори</td>
							<td>Степанаван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Степанаван, ул. Баграмяна 2а</td>
							<td>Лори</td>
							<td>Степанаван</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Алаверди, ул. Туманян 20</td>
							<td>Лори</td>
							<td>Алаверди</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Алаверди, Джравазан 2/5</td>
							<td>Лори</td>
							<td>Алаверди</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>с. Техут, 3 ул., переулок N2, зд. 2</td>
							<td>Лори</td>
							<td>Техут</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Артик, ул. Баграмяна 24</td>
							<td>Ширак</td>
							<td>Артик</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Артик, ул. Абовяна 2</td>
							<td>Ширак</td>
							<td>Артик</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Маралик, Шаиняна 4 </td>
							<td>Ширак</td>
							<td>Маралик</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Ахурян, Джрашинарарнери 2 </td>
							<td>Ширак</td>
							<td>Ахурян</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Гюмри, ул. Рыжкова 5 </td>
							<td>Ширак</td>
							<td>Гюмри</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Гюмри, ул. Горького 78 </td>
							<td>Ширак</td>
							<td>Гюмри</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Гюмри, П. Севаки 1</td>
							<td>Ширак</td>
							<td>Гюмри</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Гюмри, Привокзальная площадь 1</td>
							<td>Ширак</td>
							<td>Гюмри</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Гюмри, Площадь Независимости 4</td>
							<td>Ширак</td>
							<td>Гюмри</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Гюмри, ул. Абовяна 242/2</td>
							<td>Ширак</td>
							<td>Гюмри</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Амасиа, Здание банка </td>
							<td>Ширак</td>
							<td>Амасиа</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Егегнадзор, ул. Момика 6 </td>
							<td>Вайоц Дзор</td>
							<td>Егегнадзор</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Егегнадзор, ул. Г.Нарекаци 8</td>
							<td>Вайоц Дзор</td>
							<td>Егегнадзор</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Егегнадзор, ул. Микоян 14</td>
							<td>Вайоц Дзор</td>
							<td>Егегнадзор</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Вайк, ул. Шаумяна 100/45</td>
							<td>Вайоц Дзор</td>
							<td>Вайк</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Вайк, шоссе Джермук 11/ 52</td>
							<td>Вайоц Дзор</td>
							<td>Вайк</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Джермук, ул. Шаумяна 50</td>
							<td>Вайоц Дзор</td>
							<td>Джермук</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Джермук, ул. Шаумяна 7/5/4</td>
							<td>Вайоц Дзор</td>
							<td>Джермук</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Сисиан, ул. Воротана 1/1</td>
							<td>Сюник</td>
							<td>Сисиан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Сисиан, ул. Адонца 4</td>
							<td>Сюник</td>
							<td>Сисиан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Горис, ул. Сюника 14 </td>
							<td>Сюник</td>
							<td>Горис</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Горис, Арцахское шоссе 39/1</td>
							<td>Сюник</td>
							<td>Горис</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Горис, Анкахутян 13/1</td>
							<td>Сюник</td>
							<td>Горис</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Капан, ул. Меликяна 8/1</td>
							<td>Сюник</td>
							<td>Капан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Капан, ул. Шаумян 22/49/2</td>
							<td>Сюник</td>
							<td>Капан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Капан, ул. Степаняна 10 </td>
							<td>Сюник</td>
							<td>Капан</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Каджаран, ул. Абовяна 4/65</td>
							<td>Сюник</td>
							<td>Каджаран</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Мегри, Парамази 2</td>
							<td>Сюник</td>
							<td>Мегри</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Агарак, ул. Г.Нжде 2</td>
							<td>Сюник</td>
							<td>Агарак</td>
						</tr>
						<tr>
							<td>Банк ВТБ (Армения)</td>
							<td>г. Агарак, ул. Г.Нжде 7</td>
							<td>Сюник</td>
							<td>Агарак</td>
						</tr>
					</tbody>
				</table>
			</Container>
		</VTB_BranchTableSectionStyle>
	);
};

export default VTB_BranchTableSection;
